import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TemplateEmail } from '../models/template-email';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateEmailService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarCadenciasComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/TemplateEmail/ListaPag',
      {
        params: parametros
      });
  }

  consultarTemplates() {
    return this.http.get<TemplateEmail[]>(globals.apiUrl + '/api/TemplateEmail/ListaTodos');
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/TemplateEmail/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(arquivo) {
    return this.http.post(globals.apiUrl + '/api/TemplateEmail/Salvar', arquivo);
  }

  excluir(id) {
    return this.http.get(globals.apiUrl + '/api/TemplateEmail/Apagar',
      { params: new HttpParams().set('id', id), responseType: 'text' });
  }
}
